import * as Yup from 'yup';

export const emailTemplateSchema = Yup.object({
    emailType: Yup.number().required('Email type is required'),
    emailTypeName: Yup.string().trim().max(255, 'Maximum 255 characters').required('Email type name is required'),
    emailTemplateFileName: Yup.string().trim().max(255, 'Maximum 255 characters').required('Template file name is required'),
    emailTemplateHtmlContent: Yup.string().nullable(),
    description: Yup.string().trim().max(255, 'Maximum 255 characters').nullable(),
});
